import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import {Observable} from 'rxjs/Observable';
import {LoanApplicationService} from '../../loan-application.service';
import {EmploymentStatus} from '../../../../@models/employment-status.model';

@Component({
  selector: 'bb-career-dates',
  templateUrl: './career-dates.component.html',
  styleUrls: ['./career-dates.component.scss']
})
export class CareerDatesComponent implements OnInit {
  current_status = this.loan.form.get('current_status');
  employment_type = this.loan.form.get('employment_info.employment_type');
  employment_channel = this.loan.form.get('employment_info.employment_channel');
  looking = EmploymentStatus.KnownStatuses.looking;
  pre_employment = EmploymentStatus.KnownStatuses.pre_employment;
  done_requirements = EmploymentStatus.KnownStatuses.done_requirements;
  balik_manggagawa = EmploymentStatus.KnownStatuses.balik_manggagawa;
  working_flyback = EmploymentStatus.KnownStatuses.working_flyback;
  working = EmploymentStatus.KnownStatuses.working;
  others = EmploymentStatus.KnownStatuses.others;

  _6monthsAgo = moment().subtract(6, 'months').format('YYYY-MM-DD');
  _15yearsFromNow = moment().add(15, 'years').format('YYYY-MM-DD');
  today = moment().format('YYYY-MM-DD');

  invalid = Observable
    .merge(this.current_status.get('started_ofw').valueChanges)
    .startWith(null)
    .map(() => this.current_status.get('started_ofw').invalid);

  constructor(public loan: LoanApplicationService) {
  }

  ngOnInit(): void {
    this.current_status.get('unlimited_contract').valueChanges.subscribe(value => {
      const datetime_contract_end = this.current_status.get('datetime_contract_end');
      value ? datetime_contract_end.disable() : datetime_contract_end.enable();
    });
  }

  get employment_status(): EmploymentStatus.KnownStatuses {
    return this.current_status.get('employment_status').value;
  }
}
